import Accordion from "accordion-js";

const accordions = document.querySelectorAll(".accordion-container");
const accInstances = [];

const accordionOptions = {
    onOpen: (currElement) => {
        const rect = currElement.getBoundingClientRect();
        const isInViewport =
            rect.bottom >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight);
        if (!isInViewport) {
            const y = currElement.getBoundingClientRect().top + window.pageYOffset - 100;
            window.scrollTo({ top: y, behavior: "smooth" });
        }
    },
    showMultiple: true,
};
accordions.forEach((accordion) => {
    const isInfoBox = accordion.closest(".c-info-box");
    if (isInfoBox) {
        const localAccOptions = Object.assign(
            {
                openOnInit: [...accordion.querySelectorAll(".ac")]
                    .map((item, index) => (item.classList.contains("is-active") ? index : false))
                    .filter((item) => item !== false),
            },
            accordionOptions
        );
        accInstances.push(new Accordion(accordion, localAccOptions));
    } else {
        new Accordion(accordion, accordionOptions);
    }
});

const accordionsTogglers = document.querySelectorAll(".accordion-all");
accordionsTogglers.forEach((toggler) => {
    toggler.addEventListener("click", (e) => {
        e.preventDefault();
        const togglerIndex = [...accordionsTogglers].indexOf(toggler);
        const accordion = accInstances[togglerIndex];
        if (toggler.classList.contains("accordion-all--open")) {
            accordion.closeAll();
        } else {
            accordion.openAll();
        }
        toggler.classList.toggle("accordion-all--open");
    });
});
